import { Device } from 'mediasoup-client'
import { WebSocketTransport, Peer } from 'protoo-client'
import { CHAT, ACION_REQUEST, websocketapp, setHandleHelmetOperationResponse } from '@/common/websocket/index'
import { warning, confirmWin, alertWin } from '@/util/common'
import store from '@/store/index'
import { getSession } from '@/api/common'
import { getRtmpUrl } from '@/api/iam-manage/config'
import i18n from '@/common/i18n'

var rtmpUrl = ''

/**
 * 声音关闭
 */
const VOLUME_OFF = 0
/**
 * 声音开启
 */
const VOLUME_ON = 1

// websocket 是否连接成功
let g_is_login = false

let _closed = false

// Display name.
// @type {String}
// 初始化房间号
let _peerId = 'web' + uuid()

let _peerName = '管理员' + randomNumstr(4)
console.log(`_peerId:${_peerId} _peerName:${_peerName}`)

//当前所有peers
let _peers = {}

let roomPeers
// Device info.
// @type {Object}
let _device = {}

// Whether we want to force RTC over TCP.
// @type {Boolean}
let _forceTcp = false

// protoo-client Peer instance.
// @type {protooClient.Peer}
let _peer = null

// mediasoup-client Device instance.
// @type {mediasoupClient.Device}
let _mediasoupDevice = null

// mediasoup Consumers.
// @type {Map<String, mediasoupClient.Consumer>}
let _consumers = new Map()

// Local mic mediasoup Producer.
// @type {mediasoupClient.Producer}
let _micProducer = null

// 当前的房间号
let roomId = null

//房间是否在进行中
var g_is_meeting = false
// 已经消费的producerId
var consumeredProduIds = new Set()

// 是否有麦克风设备
let hasMic = false

var clearTime

//最后一次关闭时间
let closeTime = null

var is_leave = false //判断是否是因为加入已有会议发生的离开原有会议动作
// 录像rtmp 地址
let rtmpPrefix

let loginLink = false

/**
 * 当前用户信息
 */
let current = {
  helmetId: null,
  resolutionP: null,
  userId: null,
  userName: null,
}
/**
 * 头盔掉线处理逻辑
 * @param {String} peerId 房间用户id，头盔的格式为ms_userid，例如ms_288
 */
let handleHelmetLeave = function(peerId) {
  console.log('peerId', peerId)
  // leaveRoomSelf()
}

/**
 * 外部设置 头盔掉线处理逻辑
 * @param {Function} callback 头盔掉线处理逻辑
 */
function setHandleHelmetLeave(callback) {
  handleHelmetLeave = callback
}

/**
 * websocket与视频平台建立连接
 */
async function loginMVCP() {
  let url = store.getters.mediasoupWsUrl
  await checkMic()
  console.log('单个页面url', url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  var transport = new WebSocketTransport(url + '?peerId=' + _peerId + '&peerName=' + _peerName)
  _peer = new Peer(transport)
  _peer.on('open', () => {
    getRooms()
    setTimeout(() => {
      if (current.helmetId && loginLink) {
        helmetJoinMeet(current.helmetId, current.resolutionP, current.userId, current.username)
      }
    }, 2000)
  })

  // failed、disconnected将触发重连事件，重连10次，不成功则触发close事件
  _peer.on('failed', () => {
    g_is_login = false
    console.error('MVCP websocket 连接失败！', g_is_login)
  })

  // 监听服务端发送的请求
  _peer.on('request', async (request, accept) => {
    console.debug('proto "request" event [method:%s, data:%o]', request.method, request.data)

    switch (request.method) {
      // 断线(被占用)
      case 'peerClose': {
        // warning('该账号已从另一设备登陆')
        _peer.close()
        break
      }
      // 接收到自定义消息
      case 'routerMsg': {
        const routerMsg = request.data
        if (routerMsg.cmd) {
            console.error('unknown protoo routerMsg.cmd "%s"', routerMsg.cmd)
        }
        accept()
        break
      }
      default: {
        console.error('unknown protoo request.method "%s"', request.method)
      }
    }
  })

  //通知
  _peer.on('notification', notification => {//NOSONAR
    // console.log(notification,'delayTime')
    switch (notification.method) {
      // 生产者分数
      case 'producerScore': {
        break
      }
      // 有新的消费者
      case 'newConsumer': {
        try {
          // 处理新消费者
          getRoomPeers()
        } catch (error) {
          console.error('"newConsumer" request failed:%o', error)
          throw error
        }
        break
      }
      // 新用户加入房间
      case 'roomPeerJoin': {
        break
      }
      // 用户离开房间
      case 'roomPeerLeave': {
        getRoomPeers()
        //延时5秒判断头盔是否不再重连
        clearTime = setTimeout(function() {
          const { peerId } = notification.data
          var inRoomFlag = false
          //如果头盔在当前会议中，则标记为true
          roomPeers.roomPeers.forEach(function(peer) {
            if (peer.id === peerId) {
              inRoomFlag = true
              return
            }
          })
          if (!inRoomFlag) {
            //如果头盔主动离开房间且等于当前观看的用户id，则自动关闭视频框，并提示该头盔已掉线
            if (
              peerId.indexOf('ms_') === 0 &&
              document.getElementById('mvcpVideo').srcObject != null &&
              'ms_' + current.userId === peerId
            ) {
              console.log(current.userId, peerId, 'peerId')
              alertWin('安全帽已掉线，无法自动重连，自动退出实时视频', handleHelmetLeave)
              leaveRoomSelf()
            }
          }
        }, 10000)
        break
      }
      // 修改用户名
      case 'peerNameChanged': {
        break
      }
      // 下行带宽评估的通知
      case 'downlinkBwe': {
        break
      }
      // 消费者关闭（生产者关闭）
      case 'consumerClosed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        // 关闭
        consumer.close()
        // 从消费者列表删除
        _consumers.delete(consumerId)
        break
      }
      // 消费者暂停消费（生产者暂停）
      case 'consumerPaused': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.pause()
        break
      }
      // 消费者恢复消费
      case 'consumerResumed': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        consumer.resume()
        break
      }
      // 消费者（视频）层级变更的通知（需开启simulcast）
      case 'consumerLayersChanged': {
        const { consumerId } = notification.data
        const consumer = _consumers.get(consumerId)
        if (!consumer) break
        break
      }
      // 消费者分数
      case 'consumerScore': {
        break
      }
      // 会议当前发言人
      case 'activeSpeaker': {
        // 正常 'activeSpeaker'不回执行
        // 当 掉线5S内清除计时，重连使用
        break
      }
      default: {
        console.error('unknown protoo notification.method "%s"', notification.method)
      }
    }
  })
}

/**
 * 获取在线房间信息
 */
async function getRooms() {
  try {
    roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
    for (var i = 0; i < 6; i++) {
      roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
    }
    console.log('生成房间号:', roomId)
    const { rooms } = await _peer.request('getRooms')
    for (var j = 0; j < rooms.length; j++) {
      if (roomId === rooms[j].id) {
        // 如果房间号重复，则重新生成房间号
        roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
        for (var k = 0; k < 6; k++) roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
      }
    }
    g_is_login = true
  } catch (error) {
    warning('获取在线房间信息异常，请关闭重新打开')
    console.error('获取在线房间信息异常' + error)
  }
}
/**
 * 获取rtmp 服务地址
 */
if (getSession('access_token')) {
  getRtmpUrl().then(res => {
    console.log('rtmp地址', res)
    rtmpPrefix = res
  })
}

/**
 * 加入房间
 * @param {String} roomId 房间号
 */
async function _joinRoom(roomId, liveObj) {
  console.log(`加入房间:${roomId}`)

  // leaveRoomSelf()
  if (!_peer._connected && !_closed) {
    // 易造成发送两条join请求
    setTimeout(() => {
      _joinRoom(roomId, liveObj)
    }, 300)
  } else {
    _device = getBrowserInfo()
    // 加入房间
    await _peer.request('join', {
      roomId: roomId,
      device: _device,
      rtmpUrl: liveObj === undefined ? '' : liveObj.rtmpUrl,
    })
    /*
    // var code = randomNumstr(7)
    // var code = liveObj == undefined ? '' : liveObj.code
    // saveLiveCode(code)
    */
    g_is_meeting = true
    _mediasoupDevice = new Device()

    _closed = false

    const routerRtpCapabilities = await _peer.request('getRouterRtpCapabilities')

    // 使用mediasoup路由器的RTP功能加载设备。这就是设备如何知道允许的媒体编解码器和其他设置
    await _mediasoupDevice.load({ routerRtpCapabilities })

    // 创建媒体生产者
    await _produceMedia()

    if (store.state.helpVideo) {
      unmuteMic()
    }
  }
}

let _sendTransport
// 创建媒体生产者
async function _produceMedia() {
  try {
    // 服务器创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })
    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo

    // 本地创建sendTransport
    _sendTransport = _mediasoupDevice.createSendTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
      proprietaryConstraints: {
        optional: [{ googDscp: true }],
      },
    })

    // 监听connect，当produce调用时连接
    _sendTransport.on(
      'connect',
      (
        { dtlsParameters },
        callback,
        errback // eslint-disable-line no-shadow
      ) => {
        _peer
          .request('connectWebRtcTransport', {
            transportId: _sendTransport.id,
            dtlsParameters,
          })
          .then(callback)
          .catch(errback)
      }
    )

    // 监听produce，得到id，用于创建本地producer
    _sendTransport.on('produce', ({ kind, rtpParameters }, callback, errback) => {
      try {
        // eslint-disable-next-line no-shadow
        const { id } = _peer.request('produce', {
          transportId: _sendTransport.id,
          kind,
          rtpParameters,
        })

        callback({ id })
      } catch (error) {
        errback(error)
      }
    })
    console.log(_sendTransport)
    _sendTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected') {
          if (_sendTransport) {
            _sendTransport.close()
          }
        }
      } catch (error) {
        console.error('连接已断开，请重新连接')
      }
    })

    // 开启麦克风
    await enableMic()

    // 默认静音
    muteMic()
    // 本地默认静音
    localMiaMuteMic()
  } catch (error) {
    _micProducer = null
    console.error('发送音视频失败', error)
  }
}

let _recvTransport
// 创建媒体消费者
async function _consumeMedia() {
  try {
    // 服务端创建transport
    const transportInfo = await _peer.request('createWebRtcTransport', {
      forceTcp: _forceTcp,
    })

    const { id, iceParameters, iceCandidates, dtlsParameters } = transportInfo

    // 客户端创建recvTransport
    _recvTransport = _mediasoupDevice.createRecvTransport({
      id,
      iceParameters,
      iceCandidates,
      dtlsParameters,
      iceServers: [],
    })

    // 调用consume时connect
    _recvTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
      _peer
        .request('connectWebRtcTransport', {
          transportId: _recvTransport.id,
          dtlsParameters,
        })
        .then(callback)
        .catch(errback)
    })
    _recvTransport.on('connectionstatechange', connectionState => {
      try {
        if (connectionState === 'disconnected' && !is_leave) {
          // Close mediasoup Transports.
          if (_sendTransport) _sendTransport.close()

          if (_recvTransport) _recvTransport.close()
        } else if (_sendTransport && is_leave) {
          is_leave = false
        }
      } catch (error) {
        console.error('连接已断开，请重新连接:transport disconnected %o', error)
      }
    })
  } catch (error) {
    console.error('订阅音视频失败:_consumeMedia failed:%o', error)
  }
}

// 订阅流
async function _getConsume(peerId, _producerId) {
  console.log(peerId, _producerId, 'peerId, _producerId')
  try {
    // 服务端订阅流
    let consume = await _peer.request('consume', {
      transportId: _recvTransport.id,
      peerId,
      producerId: _producerId,
      rtpParameters: _mediasoupDevice.rtpCapabilities,
    })
    const { id, kind, producerId, producerPaused, rtpParameters } = consume
    // 只订阅当前观看设备的流
    if (peerId.indexOf('web') === -1 && !consumeredProduIds.has(_producerId)) {
      // 本地订阅流
      _transportConsume({
        peerId: peerId,
        producerId,
        id,
        kind,
        producerPaused,
        rtpParameters,
      })
      consumeredProduIds.add(_producerId)
    }
  } catch (error) {
    console.error('订阅音视频流失败', error)
  }
}

// 本地订阅流
async function _transportConsume({ peerId, producerId, id, kind, type, producerPaused, rtpParameters }) {
  const consumer = await _recvTransport.consume({
    id,
    producerId,
    kind,
    rtpParameters,
  })
  _consumers.set(consumer.id, consumer)
  consumer.on('transportclose', () => {
    _consumers.delete(consumer.id)
  })
  // 根据webrtc-svc中的规则解析给定的scalabilityMode字符串。
  // const { spatialLayers, temporalLayers } = parseScalabilityMode(consumer.rtpParameters.encodings[0].scalabilityMode)
  console.log('consumer.track', consumer.track)
  if (consumer.track.kind === 'video') {
    var videoElm = document.getElementById('mvcpVideo')
    const { track } = consumer

    videoElm.srcObject = new MediaStream([track])
    console.log(videoElm, 'videoElm', videoElm.srcObject)
    console.log('加载视频流：' + consumer.track.id)
  }
  if (consumer.track.kind === 'audio') {
    var audioElm = document.getElementById('mvcpAudio')
    const stream = new MediaStream()
    console.log('加载音频流：' + consumer.track.id)
    stream.addTrack(consumer.track)
    audioElm.srcObject = stream
  }
}

// 开启麦克风
async function enableMic() {
  console.log('打开麦克风', _micProducer, !hasMic)
  if (_micProducer) return

  //判断后台是否有麦克风，若没有，则直接返回
  if (!hasMic) {
    return
  }

  if (!_mediasoupDevice.canProduce('audio')) {
    console.error('enableMic() | cannot produce audio')
    return
  }

  let track
  console.log('track麦克风', track)
  try {
    // 获取音频流
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    track = stream.getAudioTracks()[0]

    // 创建producer
    _micProducer = await _sendTransport.produce({
      track,
      codecOptions: {
        opusStereo: 1,
        opusDtx: 1,
      },
    })
    console.log('_micProducer', _micProducer, _micProducer._track.id)

    _micProducer.on('transportclose', () => {
      _micProducer = null
    })

    _micProducer.on('trackended', () => {
      console.error('麦克风断开连接!')
      // 关闭producer
      disableMic().catch(() => {})
    })
  } catch (error) {
    console.error('enableMic() | failed:%o', error)
    if (track) track.stop()
  }
}

// 关闭麦克风
async function disableMic() {
  console.debug('disableMic()')

  if (!_micProducer) return

  // 本地关闭
  _micProducer.close()

  try {
    // 服务器关闭
    await _peer.request('closeProducer', {
      producerId: _micProducer.id,
    })
  } catch (e) {
    console.log(e)
  }

  _micProducer = null
}

/**
 * 远端流静音（暂停生产流）
 */
async function muteMic() {
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.pause()
    }
  } catch (error) {
    console.error('静音异常', error)
  }
}

/**
 * 远端流解除静音（恢复生产流）
 */
async function unmuteMic() {
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.play()
    }
    console.error('取消静音', )
  } catch (error) {
    console.error('取消静音异常', error)
  }
}
/**
 * 本地静音
 */
async function localMiaMuteMic() {
  if (!_micProducer) {
    return
  }
  _micProducer.pause()
  try {
    console.log('_micProducer end', _micProducer)
    if (_micProducer.id) {
      await _peer.request('pauseProducer', {
        producerId: _micProducer.id,
      })
    }
  } catch (error) {
    console.error('静音异常', error)
  }
}

/**
 * 本地解除静音
 */
async function localMdiaUnmuteMic() {
  if (!_micProducer) {
    return
  }
  _micProducer.resume()
  try {
    if (_micProducer.id) {
      await _peer.request('resumeProducer', {
        producerId: _micProducer.id,
      })
    }
  } catch (error) {
    console.error('取消静音异常', error)
  }
}

/**
 * 获取房间用户信息
 */
async function getRoomPeers() {
  try {
    roomPeers = await _peer.request('getRoomPeers')

    console.log('roomPeers.roomPeers:', roomPeers.roomPeers)
    await _consumeMedia()
    for (const roomPeer of roomPeers.roomPeers) {
      if (roomPeer.id !== _peerId) {
        // 获取房间用户生产者
        const { producers } = roomPeer
        producers.forEach(producer => {
          // 为每个生产者创建消费通道
          if (roomPeer.id.indexOf('web') !== 0) {
            _getConsume(roomPeer.id, producer.id)
          }
        })
      }
    }
  } catch (error) {
    console.error('获取房间用户信息失败:' + error)
  }
}

/**
 * 获取所有在线用户
 */
async function getPeers() {
  try {
    console.log('_peer', _peer)
    const { peers } = await _peer.request('getPeers')
    _peers = peers
  } catch (error) {
    console.error('获取在线用户失败', error)
  }
}

/**
 * 离开房间
 */
async function leaveRoomSelf() {
  document.getElementById('mvcpVideo').srcObject = null
  await _peer.request('leave')
  if (_sendTransport) {
    _sendTransport.close()
  }
  clearTimeout(clearTime)
  loginLink = false
  g_is_meeting = false
  roomId = ((Math.floor(Math.random() * 10000) % 7) + 1).toString()
  for (var i = 0; i < 6; i++) roomId = roomId + (Math.floor(Math.random() * 10000) % 8).toString()
}

/**
 * 检查是否是否有麦克风，若没有，则直接返回
 */
async function checkMic() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    console.log('hasMic', hasMic)
    hasMic = true
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    hasMic = false
  }
}

/**
 * 工具代码类
 */

//生成随机peerId
function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

// 生成随机数字符串
function randomNumstr(length) {
  if (typeof length != 'number') {
    length = 4
  }
  var numStr = ''
  for (var i = 0; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 获取浏览器信息
 * @returns 例如：{flag: "chrome", name: "Chrome", version: "80.0.3987.132"}
 */
function getBrowserInfo() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/
  var m = ua.match(re)
  Sys.flag = m[1].replace(/version/, "'safari")
  Sys.name = Sys.flag[0].toUpperCase() + Sys.flag.substr(1)
  Sys.version = m[2]
  return Sys
}

/**
 * 加入视频会议
 * @param {*} helmetId 头盔序列号
 * @param {*} resolutionP 清晰度
 * @param {*} userId 用户id
 * @param {*} userName 用户名
 */
async function helmetJoinMeet(helmetId, resolutionP, userId, userName) {
  // 记录当前会议人员信息
  current = {
    helmetId,
    resolutionP,
    userId,
    userName,
  }
  console.log('未延时哦')
  await getPeers()
  if (new Date() - closeTime > 5000) {
    noticeHelmetMeet(helmetId, resolutionP)
  } else {
    // console.log('延时了')
    setTimeout(() => {
      noticeHelmetMeet(helmetId, resolutionP)
    }, 3000)
  }
}
async function noticeHelmetMeet(helmetId, resolutionP) {
  if (_peers) {
    loginLink = true
    //自己先加入房间，因头盔无法加入用户数为0的房间
    if (roomId && !g_is_meeting) {
      await _joinRoom(roomId)
    }

    // action为0是加入头盔
    var sendMsg = {
      action: ACION_REQUEST.JION_ROOM,
      content: {
        g_meet_id: roomId,
        g_meet_pwd: null,
        resolution: resolutionP,
        // 0=关闭声音，1=打开声音
        volume: VOLUME_ON,
      },
    }
    CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
    setTimeout(() => {
      getRoomPeers()
    }, 1500)
  }
}

/**
 * 切换视频分辨率
 * @param {*} helmetId 头盔序列号
 * @param {*} resolutionP 清晰度
 */
async function changeResolutionP(helmetId, resolutionP) {
  if (_peers) {
    current.resolutionP = resolutionP
    // action为2，通知头盔切换分辨率，resolution代表流畅度
    var sendMsg = {
      action: ACION_REQUEST.SWITCH_RESOLUTION,
      content: {
        resolution: resolutionP,
      },
    }
    CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  }
}

// 即将离开当前页面(刷新或关闭)
window.onbeforeunload = window.onpagehide = function() {
  helmetExitMeet(current.helmetId)
  leaveRoomSelf()
}

/**
 * 通知头盔退出房间
 * @param {*} exitHelmetId 退出头盔id
 */
function helmetExitMeet(exitHelmetId) {
  console.log('通知头盔退出房间', exitHelmetId)
  //记录近一次关闭头盔实时视频的时间
  closeTime = new Date()
  //记录近一次关闭头盔实时视频的时间
  var sendMsg = {
    action: ACION_REQUEST.EXIT_ROOM,
    content: {
      webPeerId: _peerId,
    },
  }

  CHAT.chat(websocketapp.HELMET_OPERATION, exitHelmetId, sendMsg)
  _consumers.forEach(function(consu) {
    consu.close()
  })
  _consumers.clear()
  consumeredProduIds.clear()
}

/**
 * 实时视频操作响应处理，需结合具体业务调整
 * @param {Object} params 接收响应params参数
 */
function handleHelmetOperationResponse(params) {
  if (params.helmetId !== current.helmetId) {
    // 当收到别的头盔的信息时不进行任何处理
    return
  }
  var status = JSON.parse(params.status)
  console.log(status, 'status')
  if (status.action === 2) {
    console.log('安全帽加入房间结果：' + status.enterResult)
    if (!status.enterResult) {
      alertWin(i18n.t('videoConnectionFailed'), handleHelmetLeave)
    }
    return
  }
  if (status.action === 1) {
    console.log(`拍照状态:${status.camera}`)
    return
  }
  // 如果头盔已经在会议中，则直接加入会议
  if (status.roomId && document.getElementById('mvcpVideo').srcObject == null) {
    if (_sendTransport) {
      _sendTransport.close()
    }
    leaveRoomSelf()
    // 因头盔返回的roomId为数字，需要转成字符
    roomId = '' + status.roomId
    console.log('会议中', rtmpUrl)
    //防止关闭新的_sendTransport
    is_leave = true
    let objectUrl = { rtmpUrl: rtmpUrl }
    _joinRoom(roomId, objectUrl)
    // 创建媒体消费者
    getRoomPeers()
  }
  if (status.isFaceScan) {
    warning(current.userName + '安全帽正在进行人脸识别，请稍后连接!')
    return
  }
  if (status.isQRScan) {
    warning(current.userName + '安全帽正在进行二维码扫描，请稍后连接!')
    return
  }
  if (status.isSwitchUser) {
    warning(current.userName + '安全帽正在进行切换用户，请稍后连接!')
    return
  }
  if (status.isAgoraSpeech) {
    warning(current.userName + '麦克风已被占用!')
    return
  }
  if (status.isRecord) {
    confirmWin(
      current.userName + i18n.t('RecordingPreemptOrNot'),
      () => {
        // 点击确定，抢占录像
        grabRecord(params.helmetId)
      },
      () => {
        // 点击取消事件 关闭直播框
        handleHelmetLeave()
      }
    )
    return
  }
  if (
    status.resolution &&
    status.resolution !== current.resolutionP &&
    params.helmetId === current.helmetId &&
    !params.liveUrl
  ) {
    store.commit('handleresolutionP', status.resolution)
    warning('其他用户修改了分辨率，已为您自动切换分辨率!')
  }
}
/**
 * 抢占视频
 */
function grabRecord(helmetId) {
  var sendMsg = {
    action: 4,
    content: {
      g_meet_id: roomId,
      g_meet_pwd: null,
      resolution: current.resolutionP,
      volume: VOLUME_ON,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
}
export { VOLUME_OFF, VOLUME_ON, loginLink }

export {
  setHandleHelmetOperationResponse,
  setHandleHelmetLeave,
  handleHelmetOperationResponse,
  helmetJoinMeet,
  grabRecord,
  helmetExitMeet,
  changeResolutionP,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  loginMVCP,
  localMdiaUnmuteMic,
  localMiaMuteMic
}
